const features = [
  { icon: 'ri-4k-line', title: '蓝光4K画质', desc: '支持从高清720P到蓝光4K多种清晰度，智能匹配最佳画质，每一帧都清晰细腻，带来影院级视觉享受。' },
  { icon: 'ri-flashlight-line', title: '秒开不缓冲', desc: '全球CDN加速节点覆盖，先进视频编码技术加持，点击即播无需等待，告别加载转圈的烦恼。' },
  { icon: 'ri-vip-diamond-line', title: '永久免费', desc: '无需注册、无需付费、无需会员，全站影视内容永久免费观看，真正做到开放共享，让好内容触手可及。' },
  { icon: 'ri-stack-line', title: '海量资源', desc: '收录超过万部高清影视作品，涵盖国产剧、韩剧、美剧、日剧、动漫、综艺等全品类，每日持续扩充更新。' },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-100 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-8">
          平台优势
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feat, i) => (
            <div key={i} className="bg-background-50 rounded-lg border border-background-200/70 p-6 text-center">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-4">
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">{feat.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}